import React from 'react';

const P404: React.FC = () => <h2>not found</h2>;

export default P404;
